import { render, staticRenderFns } from "./FeaturePreview.vue?vue&type=template&id=5c23eb1f&"
import script from "./FeaturePreview.vue?vue&type=script&lang=js&"
export * from "./FeaturePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports